import { useState, useRef } from "react";
import { Box } from "@mui/material";
import { useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { tableCellClasses } from '@mui/material/TableCell';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectedPairDetail } from "../../Actions/TradePage/STPAction";
import { getTopMarketTradePairList } from "../../Actions/TradePairs/TopMarketListAction";
import PreLoader from "../Loaders/PreLoader";
import socket from "../../utils/Socket";
import useBinanceAllTickers from "../../socket/BinanceMarketSocket";
import { getAllTradePairList } from "../../Actions/TradePairs/TradePairAction";
import { handleImageError } from "../../Helper/helper";
import { a11yProps, CustomTabPanel } from "../common/CustomTabs";

const StyledTableCell = styled(TableCell)(() => ({
    padding: '0px !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#3665ff',
        color: '#fff',
        padding: '0px 10px !important',
        fontSize: 13,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        border: 'none',
        padding: '4px 10px !important',
    },
}));
const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(even)': {
        // backgroundColor: '#3665ff0d',
        border: 'none',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',
    },

    '&:hover': {
        backgroundColor: '#3665ff0d',
        cursor: 'pointer',
    },
}));

function USDT() {

    // Hooks
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Selectors
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { userDetailData, isFirstLoad, userDetailStatus } = useSelector((state) => state.user);
    const { tradePairData, tradePairLoading, tradePairStatus } = useSelector(state => state.tradePair);
    const { stpLoading, stpData, stpError, stpStatus, selectedPair } = useSelector((state) => state.tradeSTP);
    const { topMarketListData, topMarketListError, topMarketListLoading, topMarketListStatus } = useSelector((state) => state.topMarketList);

    // Refs
    const hasFetched = useRef(false)
    const hasFetchedOnce = useRef(false);

    // States
    const [spotTradePairList, setSpotTradePairList] = useState([]);
    const [trendingPair, setTrendingPair] = useState([]);
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("symbol");
    const [tradePairDetail, setTradePairDetail] = useState({})
    const { tickers, loading } = useBinanceAllTickers();

    useEffect(() => {
        dispatch(getAllTradePairList({ type: 'all' }));
    }, [dispatch]);

    useEffect(() => {
        if (!tradePairLoading) {
            setSpotTradePairList(tradePairData?.data || []);
        }
    }, [tradePairLoading]);

    useEffect(() => {
        if (!topMarketListData && !hasFetched.current) {
            dispatch(getTopMarketTradePairList());
            hasFetched.current = true;
        }
    }, [topMarketListData, dispatch]);

    useEffect(() => {
        if (topMarketListStatus === true) {
            setTrendingPair(topMarketListData?.result?.trendingList)
        } else {
        }
    }, [topMarketListStatus]);

    const uniqueCoinTwos = [];
    const uniqueItems = [];

    const [value2, setValue2] = useState(0);
    const [selectedTabLabel, setSelectedTabLabel] = useState(
        uniqueCoinTwos?.[0] || ""
    );

    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
        setSelectedTabLabel(uniqueCoinTwos?.[newValue]);
    };

    spotTradePairList?.forEach(item => {
        if (!uniqueCoinTwos.includes(item.coinTwo)) {
            uniqueCoinTwos.push(item.coinTwo);
            uniqueItems.push(item);
        }
    });


    useEffect(() => {
        if (id) {
            // getTradePairDetail(id)
            setTradePairDetail(selectedPair)
        }

    }, [id, selectedPair]);


    useEffect(() => {
        // no-op if the socket is already connected
        socket.connect();
        return () => {
            socket.disconnect();
        };
    }, []);


    useEffect(() => {
        if (userDetailData) {
            socket.emit("register", {
                ui: btoa(userDetailData?._id),
                //   ui: "marketPrice",
                role: "user",
            });
        }
    }, [userDetailData]);

    useEffect(() => {

        socket.emit("live_market_price", "marketPrice");
        const handleMarketPrice = (result) => {
            if (!Array.isArray(result)) return;

            setTrendingPair((prevList) =>
                prevList.map((item) => {
                    const updated = result.find(
                        (res) => res && (res.coinOne === item.source)
                    );
                    if (updated) {
                        return {
                            ...item,
                            usd_price: updated.lastPrice ?? item.usd_price,
                            change24h: updated.change24h ?? item.change24h,

                        };
                    }

                    return item;
                })
            );

        };

        socket.on("marketPrice", handleMarketPrice);

        return () => {
            socket.off("marketPrice", handleMarketPrice);
            socket.emit("live_market_price_remove", "marketPrice");
        };
    }, [spotTradePairList, tradePairDetail]);

    const handleTableRowClick = (item) => {
        dispatch(selectedPairDetail(item))
        const queryParams = new URLSearchParams(location.search);
        queryParams.set("symbol", item?.symbol);
        navigate(`${location.pathname}?${queryParams.toString()}`);
    }

    useEffect(() => {
        if (!tickers || tickers.length === 0) return;

        setSpotTradePairList(prev => {
            const tickerMap = new Map(
                tickers.map(t => [t.symbol, t])
            );

            return prev.map(p => {
                const t = tickerMap.get(p.symbol);
                if (!t) return p;

                const price = Number(t.lastPrice);
                const change = Number(t.change24h);

                return {
                    ...p,
                    lastPrice:
                        !isNaN(price) && price > 0
                            ? t.lastPrice
                            : p.lastPrice,

                    change24h:
                        !isNaN(change)
                            ? t.change24h
                            : p.change24h,

                };
            });
        });
    }, [tickers]);


    const formatPrice = (price, decimal = 5) => {
        if (price === null || price === undefined || price === "") return "--";

        const num = Number(price);
        if (Number.isNaN(num)) return "--";

        return num.toFixed(decimal);
    };





    if (stpLoading || loading) {
        return <PreLoader />
    }
    return (

        <div>

            <Box sx={{ background: "var(--color-BasicBg)", paddingBottom: '5px' }} className="display-2 ads-tab tab-cmn">
                <Tabs
                    value={value2}
                    onChange={handleChange2}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{ minHeight: "30px" }}
                >
                    {uniqueCoinTwos?.map((item, index) => (
                        <Tab
                            key={item}
                            sx={{ fontSize: "12px" }}
                            label={item}
                            {...a11yProps(index)}
                        />
                    ))}
                </Tabs>
            </Box>

            {
                spotTradePairList?.length > 0 &&
                [...new Set(spotTradePairList.map(item => item.coinTwo))].map((coinTwo, index) => (
                    <CustomTabPanel value={value2} index={index} className="ord-bk-table">
                        <TableContainer sx={{ maxHeight: '600px', scrollbarWidth: 'none', borderRadius: '6px 6px 6px 6px' }}>
                            <Table sx={{ minWidth: 250, background: "var(--color-BasicBg)" }} stickyHeader aria-label="trade history table">
                                <TableHead sx={{ position: "sticky", top: "0px", background: "#fff" }}>
                                    <TableRow>
                                        <StyledTableCell >Pairs</StyledTableCell>
                                        <StyledTableCell align="right">Last Price</StyledTableCell>
                                        <StyledTableCell align="right">24h Change</StyledTableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {
                                        spotTradePairList
                                            .filter(item => item.coinTwo === coinTwo)
                                            .map((item, idx) => (

                                                <StyledTableRow key={item.symbol + idx}
                                                    onClick={() => handleTableRowClick(item)}>

                                                    <StyledTableCell component="td" scope="row">
                                                        <div className="display-1" style={{ gap: "8px", alignItems: "center", whiteSpace: "nowrap", }} >
                                                            <img src={item?.baseImage} width="20" height="20" alt={item?.symbol} onError={handleImageError} />
                                                            <p style={{ margin: 0, fontWeight: 600 }}>{item?.symbol}</p>
                                                        </div>
                                                    </StyledTableCell>

                                                    <StyledTableCell align="right">
                                                        {formatPrice(item?.lastPrice ?? item?.openPrice ?? item?.usd_price, item?.priceDecimal || 5)}
                                                    </StyledTableCell>

                                                    <StyledTableCell align="right" className={`coin-change-${item.symbol}`}>
                                                        <span className={`sml-txt ${parseFloat(item?.change24h) >= 0 ? 'green' : 'red'}`}>
                                                            {!isNaN(Number(item?.change24h)) ? `${Number(item.change24h).toFixed(2)}%` : "--"}
                                                        </span>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>

                    </CustomTabPanel>
                ))
            }
        </div>



    );
}

export default USDT;
